

import appInfo from './config';

async function checkAvailability(q) {
    const apiEndUrl = '/public/chatmanager/available';
    return fetch(appInfo.server + apiEndUrl, {
        method: 'GET',
        headers: { Name: q, Guid: 'a4cdb96e-b2be-4709-b143-b7af3fea7a42' }
      })
      .then(response => response.json())
      .catch(error => {
        console.error(error);
      });
}

export default {
    checkAvailability
};
